import Vue from 'vue';

export default Vue.component('notification', {
  template: require('./template.html'),
  data() {
    return {
      classType: `editorUi-notification-${this.notification.type}`,
    };
  },
  name: 'notification',
  props: ['notification', 'index'],
  methods: {
    removeNotification(i) {
      this.$store.dispatch('removeNotification', i);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/notifications/notification/index.js